import { useEffect, useState } from "react";

/**
 * Shared Hey MR session state for the D.A.R. mic button.
 *
 * The mic button is always the D.A.R. voice-memo control; it merely *shows*
 * whether Hey MR is currently listening or speaking. This tiny store keeps the
 * two features decoupled — neither owns the other, and nothing here touches
 * recording, Deepgram calls, or authorization.
 */
export type MrVoiceMicState = "off" | "idle" | "standby" | "listening" | "speaking";

let current: MrVoiceMicState = "off";
const listeners = new Set<(s: MrVoiceMicState) => void>();

export function setMrVoiceMicState(next: MrVoiceMicState) {
  if (next === current) return;
  current = next;
  listeners.forEach((l) => l(next));
}

export function getMrVoiceMicState(): MrVoiceMicState {
  return current;
}

export function useMrVoiceMicState(): MrVoiceMicState {
  const [state, setState] = useState<MrVoiceMicState>("off");

  useEffect(() => {
    setState(current);
    const l = (s: MrVoiceMicState) => setState(s);
    listeners.add(l);
    return () => {
      listeners.delete(l);
    };
  }, []);

  return state;
}
